module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n        Search By\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Disbursement Date From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disbursementStartDate),
      expression: "form.disbursementStartDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "disbursementStartDate",
      "placeholder": "Disbursment Start Date"
    },
    domProps: {
      "value": (_vm.form.disbursementStartDate)
    },
    on: {
      "change": _vm.changeFilter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "disbursementStartDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Disbursement Date To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disbursementEndDate),
      expression: "form.disbursementEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "disbursementEndDate",
      "placeholder": "Disbursment End Date"
    },
    domProps: {
      "value": (_vm.form.disbursementEndDate)
    },
    on: {
      "change": _vm.changeFilter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "disbursementEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("EMI End Date From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.startEmiEndDate),
      expression: "form.startEmiEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "startEmiEndDate",
      "placeholder": "Disbursment Start Date"
    },
    domProps: {
      "value": (_vm.form.startEmiEndDate)
    },
    on: {
      "change": _vm.changeFilter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "startEmiEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("EMI End Date To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.endtEmiEndDate),
      expression: "form.endtEmiEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "endEmiEndDate",
      "placeholder": "Disbursment Start Date"
    },
    domProps: {
      "value": (_vm.form.endtEmiEndDate)
    },
    on: {
      "change": _vm.changeFilter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "endtEmiEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.canAccess('loan-disbursement-delete')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Select Branch")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadStaff]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                Select Company Branch\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(branch) {
    return _c('option', {
      key: branch.id,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v("\n                " + _vm._s(branch.name) + "\n              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-update')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "agent_id",
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Staff"
    },
    on: {
      "input": _vm.getRecordByStaff
    },
    model: {
      value: (_vm.staf),
      callback: function($$v) {
        _vm.staf = $$v
      },
      expression: "staf"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agent_id"
    }
  })], 1)]) : _vm._e()])])]), _vm._v(" "), (_vm.canAccess('loan-disbursement-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member_loan_plan.applicationNo))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.planName(row.plan)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.planCategory))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.planRecoveryType(row.plan)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.planAmt(row)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.disAmt(row)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.disbursementDate)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.emiStartDate)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.emiEndDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.member.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.agent) ? _c('span', [_vm._v(_vm._s(row.agent.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                " + _vm._s(row.branch_ledger.ledger.name) + "\n              ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group"
    }, [(_vm.canAccess('loan-disbursement-update')) ? _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.status == 'pending'),
        expression: "row.status == 'pending'"
      }],
      staticClass: "btn btn-success btn-xs",
      on: {
        "click": function($event) {
          return _vm.editModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-delete')) ? _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.status == 'disbursed' || row.status == 'pending'),
        expression: "row.status == 'disbursed' || row.status == 'pending'"
      }],
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function($event) {
          return _vm.deleteDisbursment(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.filechargeStatus == 'exclude'),
        expression: "row.filechargeStatus == 'exclude'"
      }],
      staticClass: "btn btn-warning btn-xs",
      attrs: {
        "title": "File Charge"
      },
      on: {
        "click": function($event) {
          return _vm.fileChargeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.processingFeeStatus == 'exclude'),
        expression: "row.processingFeeStatus == 'exclude'"
      }],
      staticClass: "btn btn-warning btn-xs",
      attrs: {
        "title": "Processing Fee"
      },
      on: {
        "click": function($event) {
          return _vm.processingFeeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-hourglass"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.insuranceFeeStatus == 'exclude'),
        expression: "row.insuranceFeeStatus == 'exclude'"
      }],
      staticClass: "btn btn-warning btn-xs",
      attrs: {
        "title": "Insurance Fee"
      },
      on: {
        "click": function($event) {
          return _vm.insuranceFeeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user-md"
    })]), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('button', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "title": "For Staff"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    })]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('button', {
      staticClass: "btn btn-info btn-xs",
      attrs: {
        "title": "For Customer"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintCustomerModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-hand-o-up"
    })]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('button', {
      staticClass: "btn btn-info btn-xs",
      attrs: {
        "title": "Loan EMI Card"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintCustomerEMIModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-book"
    })]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('button', {
      staticClass: "btn btn-info btn-xs",
      attrs: {
        "title": "Dimand ProbeshnaryNote"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintDimandProbeshnoryNote(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sticky-note-o"
    })]) : _vm._e()])])])
  }), 0)])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "fileChargeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(4), _vm._v(" "), _c('form', {
    on: {
      "~submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect File Charge ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(6)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "processingFeeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(7), _vm._v(" "), _c('form', {
    on: {
      "~submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect Processing Fee ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(9)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "insuranceFeeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(10), _vm._v(" "), _c('form', {
    on: {
      "~submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect Insurance Fee ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(12)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(13), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "print"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.myhost === 'bullet.microfinancesoftware.in') ? _c('div', [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px"
    }
  }, [_c('thead', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-width": "2px",
      "text-align": "center"
    }
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                          "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                          ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-width": "2px",
      "text-align": "center"
    },
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.member_loan_plan.applicationNo,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                            Show this if the rendering fails.\n                          ")])], 1)])]), _vm._v(" "), _c('h1', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Loan Agreement")]), _vm._v(" "), (_vm.seeRecord.status == 'disbursed') ? _c('div', [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px"
    }
  }, [_c('thead', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('th', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Branch : " + _vm._s(_vm.seeRecord.branch.name) + " (" + _vm._s(_vm.seeRecord.branch.branchCode) + ")")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date : " + _vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-width": "1px"
    }
  }, [_c('tr', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._m(14), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.seeRecord.member.name) + " (" + _vm._s(_vm.seeRecord.member.code) + ")")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Contact No : ")]), _vm._v(_vm._s(_vm.seeRecord.member.mobile))]), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("DOB :")]), _vm._v(" " + _vm._s(_vm._f("myDate")(_vm.mem.dob)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v(" Gender : ")]), _vm._v(_vm._s(_vm.mem.gender))]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  })]), _vm._v(" "), (_vm.mem.spouseName) ? _c('tr', [_vm._m(16), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.spouseName))]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  })]) : _c('tr', [_vm._m(17), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.fatherName))]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  })]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('tr', [_vm._m(19), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.address) + ", " + _vm._s(_vm.mem.area))]), _vm._v(" "), _vm._m(20), (_vm.mem.state) ? _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.district) + ", " + _vm._s(_vm.mem.state.name) + " - " + _vm._s(_vm.mem.pin))]) : _vm._e()]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Bank : ")]), _vm._v(" "), (_vm.mem.bank) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bank.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Branch : ")]), (_vm.mem.bankBranch) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bankBranch))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Loan ID :")]), _vm._v(" "), (_vm.seeRecord.member_loan_plan) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Plan Name :")]), _vm._v(" " + _vm._s(_vm.pl.name))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Account Holder : ")]), _vm._v(_vm._s(_vm.mem.accountHolderName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Account Number : ")]), _vm._v(" "), (_vm.mem.accountNumber) ? _c('span', [_vm._v(_vm._s(_vm.mem.accountNumber))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate (%) : " + _vm._s(_vm.pl.rateOfInterest))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("GST Include : ")]), _vm._v(_vm._s(_vm.pl.includeGst))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("IFSC : ")]), _vm._v(_vm._s(_vm.mem.ifsc))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Plan Amount :")]), _vm._v(" " + _vm._s(_vm.planAmt(_vm.seeRecord)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("File Charge : ")]), _vm._v(_vm._s(_vm.fileChargeFee(_vm.seeRecord)))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_vm._m(22), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Processing Fee :")]), _vm._v(" " + _vm._s(_vm.processingFee(_vm.seeRecord)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Insurance Fee :")]), _vm._v(" " + _vm._s(_vm.insuranceFee(_vm.seeRecord)))])]), _vm._v(" "), (_vm.pl.rateOfInterest) ? _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Income (INR) : ")]), _vm._v(_vm._s(_vm.mem.incomeAmount))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Occupation : ")]), _vm._v(_vm._s(_vm.mem.jobType))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Recovery type :")]), _vm._v(" " + _vm._s(_vm.pl.recoveryType))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Amount to be Paid :")]), _vm._v(" "), (_vm.seeRecord.loanAmount) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.loanAmount))]) : _c('span', [_vm._v(" " + _vm._s(_vm.pl.amount))])])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Business Name : ")]), _vm._v(_vm._s(_vm.mem.businessName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Income Type : ")]), _vm._v(_vm._s(_vm.mem.incomeType))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("No of Payments : ")]), _vm._v(" "), (_vm.pl.noOfPayments) ? _c('span', [_vm._v(_vm._s(_vm.pl.noOfPayments))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Minimum Income : ")]), _vm._v(_vm._s(_vm.mem.minAmount))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Purpose : ")]), (_vm.seeRecord.purpose) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.purpose.purpose))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Description : ")]), _vm._v(_vm._s(_vm.seeRecord.description))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._m(23), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "120px",
      "height": "140px",
      "float": "right",
      "text-align": "center"
    }
  }, [_c('br'), _c('center', [_vm._v("Guarantor Photo "), _c('br'), _vm._v("with Cross Sign")])], 1)])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._m(24), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.guarantorName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Contact Number : ")]), _vm._v(_vm._s(_vm.mem.guarantorPhone) + " ")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._m(25), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.guarantorAddress))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Narration : ")]), _vm._v(_vm._s(_vm.mem.guarantorNarration))])]), _vm._v(" "), _c('tr', [_vm._m(26), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Nominee Name : ")]), _vm._v(_vm._s(_vm.mem.nomineeName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Contact Number : ")]), _vm._v(_vm._s(_vm.mem.nomineePhone))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Nominee Dob : ")]), _vm._v(_vm._s(_vm.mem.nomineeDob))])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Repayment Schedule Terms ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_vm._m(27), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-width": "2px"
    }
  }, _vm._l((_vm.memberEmiRecords), function(memberEmiRecord) {
    return _c('tr', {
      key: memberEmiRecord.id,
      staticStyle: {
        "border-width": "2px",
        "border-style": "solid"
      }
    }, [_c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black",
        "border-style": "solid"
      }
    }, [_vm._v(_vm._s(memberEmiRecord.emiNo))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black",
        "border-style": "solid"
      }
    }, [_vm._v(_vm._s(memberEmiRecord.emiDate))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black",
        "border-style": "solid"
      }
    }, [_vm._v(_vm._s(memberEmiRecord.intrest))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black",
        "border-style": "solid"
      }
    }, [_vm._v(_vm._s(memberEmiRecord.principal))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black",
        "border-style": "solid"
      }
    }, [_vm._v(_vm._s(memberEmiRecord.total))])])
  }), 0)]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', [_vm._v("1. उपरोक्त सभी पक्ष निम्नलिखित सभी शर्ते व नियम पर अपनी सहमति व्यक्त करते हैं यह है कि ऋण धारी इस राशि का उपयोग माइक्रोफाइनेंस की नियमावली समझकर करेंगे तथा इस राशि या इसके किसी भी अंश का उपयोग अन्य किसी भी उद्देश्य की पूर्ति हेतु नहीं करेंगे जिसके लिए इसे स्वीकृत नहीं किया गया है हम इसके लिए भी सहमति व्यक्त करते हैं कि यदि कंपनी को सबसे कोई कारण मिलता है जो स्पष्ट करता है कि सर्च की पालना नहीं की गई है तो कंपनी को अधिकार है कि वह इस ऋण राशि या उसके अंश को बिना किसी रियायत के वापस ले लेंगे")]), _vm._v(" "), _c('p', [_vm._v("2. मैं /हम लोन के लिए आवेदन करने वाले तथा गारंटर पूर्व में किसी भी गैर कानूनी कार्य में लिप्त नहीं है और ना ही किसी न्यायालय में हमारे विरुद्ध आपराधिक मामला विचाराधीन है और ना ही किसी भी थाने में कोई एफ आई आर दर्ज है।")]), _vm._v(" "), _c('p', [_vm._v("3. यह है कि मैं / हमें किसी वित्तीय संस्थान, बैंक या फाइनेंस कंपनी से मुझे / हमको डिफॉल्टर घोषित नहीं किया गया है।")]), _vm._v(" "), _c('p', [_vm._v("4. यह है कि मैं हम उक्त लोन की संपूर्ण किस्तों का भुगतान करने में पूरी तरह से सक्षम है और किसी भी विपरीत परिस्थिति में मैं हम भुगतान करने में देरी नहीं करेंगे।")]), _vm._v(" "), _c('p', [_vm._v("5. यह है कि कंपनी का जो भी कर्मचारी किस्त की राशि का कलेक्शन करने आएगा मैं उसके साथ विनम्र व्यवहार रखूंगा  रखेंगे एवं उसे किसी भी प्रकार की आपत्तिजनक बात ना कहेंगे किसी भी प्रकार का उसको नुकसान या मारपीट की कोशिश नहीं करेंगे और ना ही उसके खिलाफ गंदे व्यवहार या अपशब्द बोलने आरोप नहीं लगाएंगे अगर हमारे द्वारा कोई भी अभद्र व्यवहार किया जाता है तो कंपनी कर्मचारी तथा कंपनी हमारे प्रति कानूनी कार्रवाई करने के लिए स्वतंत्र होंगे")]), _vm._v(" "), _c('p', [_vm._v("6. यह है कि मैं हम नियत तिथि की सूचना देने से संबंधित जानकारी अपनी किस्तों के संपूर्ण भुगतान के लिए नोटिस रिमाइंडर व इलेक्ट्रॉनिक सूचना फोन इत्यादि करने के लिए कंपनी जिम्मेदार नहीं होगी इस बात की याददाश्त संबंधित संपूर्ण जिम्मेदारी मेरी या  हमारी होगी")]), _vm._v(" "), _c('p', [_vm._v("7. यह है कि अगर ऋणी या गारंटर अपने व्यवसाय नौकरी मूल निवास मोबाइल नंबर या ईमेल आईडी का परिवर्तन करता है तो इस बात की सूचना कंपनी को पूर्व में लिखित प्रदान करेंगे")]), _vm._v(" "), _c('p', [_vm._v("8. यह है कि मैं /हम यह वचनबद्ध बयान करते हैं कि भविष्य में यदि हमारे द्वारा किस्तों का भुगतान चेक के माध्यम से किया जाता है तो हम दिए गए चेकों को बैंक में स्टॉप नहीं कराएंगे और ना ही उक्त चेक के खोने की रिपोर्ट दर्ज थाने में कराएंगे और ना ही उक्त खाते को बंद कर आएंगे यदि हम ऐसा करते हैं तो कंपनी हमारे विरुद्ध कानूनी कार्रवाई करने का अधिकार रखेगी !")]), _vm._v(" "), _c('p', [_vm._v("9. यह है कि कंपनी द्वारा के संग्रहण संबंधित जो सुविधाएं जैसे कि s.m.s. कॉलिंग मेल किया नोटिस प्रदान करने के लिए जो भी सर्विस चार्ज अलग से मांगेंगे वह हम प्रदान करेंगे|")]), _vm._v(" "), _c('p', [_vm._v("10. यह है कि इस अनुबंध के अनुसार गारंटर की पूरी जिम्मेदारी और उत्तरदायित्व  है अगर भविष्य में आवेदक के साथ  कोई आकस्मिक घटना मृत्यु या दिवालिया या गंभीर बीमारी हो जाती है तो संपूर्ण लोन का भुगतान गारंटर द्वारा किया जाएगा")]), _vm._v(" "), _c('p', [_vm._v("11. यह है कि हम मैं द्वारा कंपनी को दी गई संपूर्ण जानकारी मौखिक प्रदान की गई है जो कि सत्य व सही है जिसमें किसी भी प्रकार का कोई भी झूठा तथ्य नहीं बताया गया है यदि कोई जानकारी झूठी पाई जाती है तो कंपनी हमारे विरोध कानूनी कार्रवाई करने का अधिकार रखेगी मैं हम ने लोन के बारे में समस्त जानकारी जैसे ब्याज कथा किस्तों की राशि किस्तों का समय और अदायगी का समय अच्छी तरह से समझ लिया है कंपनी कर्मचारी द्वारा मुझे संपूर्ण जानकारी दे दी गई है उक्त सभी नियमों व शर्तों के लिए मैं हम पूरी तरह तैयार है और अगर मैं हम किस्त देने में देरी करते हैं तो उस पर लगने वाला अतिरिक्त भार लीगल खर्चा पेपर खर्चा विजिट खर्चा व अन्य खर्च जो भी भविष्य में आएगा वह हमारे द्वारा प्रदान किया जाएगा | ")]), _vm._v(" "), _c('p', [_vm._v("12. यह है कि मैं हम प्रस्तुत किए गए समस्त दस्तावेज जैसे कि आधार कार्ड पैन कार्ड राशन कार्ड ड्राइविंग लाइसेंस बैंक की पासबुक व फोटो के साथ किसी भी तरह की छेड़छाड़ या कोई भी फर्जी दस्तावेज हमारे द्वारा प्रस्तुत नहीं किया गया है निकट भविष्य में अगर किसी भी दस्तावेज के फर्जी पाए जाने पर हमारे खिलाफ 420 ई का मुकदमा कंपनी द्वारा किया जा सकता है किस बात से हम पहले से जानकार हैं | ")]), _vm._v(" "), _c('p', [_vm._v("13. यह है कि हम मैं अपनी किस्तों का भुगतान साप्ताहिक रूप में करना चाहता हूं | ")]), _vm._v(" "), _c('p', [_vm._v("14. यह है कि इस ऋण के भुगतान और उसके बकाया या किसी भी अंश की स्वीकृति या किसी भी अन्य विशिष्ट कार्य हेतु जब भी कंपनी द्वारा बुलाया जाएगा मैं हम समय पर उपस्थित हो जाएंगे | ")]), _vm._v(" "), _c('p', [_vm._v("15. यह है कि मेरी सालाना आय ₹500000 से कम है उक्त एग्रीमेंट या लोन को करते समय हमने किसी भी प्रकार का कोई नशा नहीं किया हुआ है हम पूरे होशो हवास में यह एग्रीमेंट कर रहे हैं | ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', [_vm._v("1. All the above parties agree on all the following terms and condition that the borrower will use this amount as\n                      per the rules of microfinance and will not use this amount or any part of it for any other purpose. We also agree\n                      that if the company finds any reason to explain which has not been complied with, the company has the right to\n                      withdraw this loan amount or part thereof without any Will withdraw the concession.")]), _vm._v(" "), _c('p', [_vm._v("2. I and my guarantor are not involved in any illegal act in the past and neither a criminal case is pending against\n                      us in any court nor any FIR is registered in any police station.")]), _vm._v(" "), _c('p', [_vm._v("3. That I/We are not burdened with any kind of loan from any financial institution, bank finance company, nor\n                      have I/we been declared a defaulter from any financial institution, bank or finance company.")]), _vm._v(" "), _c('p', [_vm._v("4. That I/we are fully capable of paying the entire instalments of the said loan and I/We shall not delay the\n                      payment under any circumstances")]), _vm._v(" "), _c('p', [_vm._v("5. That whichever employee of the company will come to collect the instalment amount, I will keep polite\n                      behaviour with them and will not call him any kind of objectionable thing, will not try to harm or beat him in any\n                      way nor will he be dirty against him. Will not allege behaviour or abusive language If any abusive behaviour is\n                      done by us then company will be free to take legal action against us.")]), _vm._v(" "), _c('p', [_vm._v("6. That I/We the company will not be responsible for giving notices, reminders and electronic information\n                      phone etc. For the full payment of my instalments related to intimation of the due date of payment of the loan,\n                      the entire responsibility related to this will be my / ours.")]), _vm._v(" "), _c('p', [_vm._v("7. That if the Borrower (s) or the Guarantor (s) change their business, job, Domicile , Mobile number or email\n                      Id, they shall give prior written notice to the company.")]), _vm._v(" "), _c('p', [_vm._v("8. That I / We undertake to make a statement that if the instalments are paid by us in future through are paid by\n                      us in future through cheque, then we will not make stop payment of the checks given in the bank nor report the\n                      loss of the said check to the police station. Nor will we close that account, if we do so, the company will have the\n                      right to take legal action against us.")]), _vm._v(" "), _c('p', [_vm._v("9. This is during the Company’s storage related facilities Such as S.M.S. we will provide the additional service\n                      charge required for providing the calling, email notice.")]), _vm._v(" "), _c('p', [_vm._v("10. That the guarantor is fully responsible and liable as per this agreement, if any accidental event ,death or\n                      insolvency or serious illness occurs with the application future, the entire loan shall be paid by the guarantor.")]), _vm._v(" "), _c('p', [_vm._v("11. That all the information given by me/us to the company has been provided orally which is the true and\n                      correct in which no false fact of any kind have been told , if any information is found to be false then the\n                      company has the right to take legal action against us. I will keep all the information about the loan, Such as the\n                      amount of interest. Instalment, the time of instalment and the time of repayment. I have been given complete\n                      information by the company employee, we are fully prepared for all the above terms and condition and if\n                      me/we delay in paying the instalment, then the additional burden of legal expanses and other expenses which\n                      will come in future will be provided by us.")]), _vm._v(" "), _c('p', [_vm._v("12. That all the documents submitted by me/us Such as Aadhar card, Pan card , Ration card, Driving license,\n                      Bank Passbook and Photo have not been tampered with or any fake document has been submitted by us near in\n                      future, if any document is found to be forged, we can be sued for 420 by the company, which we are already\n                      aware of.")]), _vm._v(" "), _c('p', [_vm._v("13. That me/we want to pay our instalments monthly.")]), _vm._v(" "), _c('p', [_vm._v("14. That I/we shall be present in time as and when called for by the company for the payment of this loan and\n                      acceptance of the arrears or any part thereof or for any other specified purpose. ")]), _vm._v(" "), _c('p', [_vm._v("15. That my annual income is less than 500000/-, we have not done any kind of intoxication while doing the said\n                      agreement or loan, we are doing this agreement in full consciousness.")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.status == 'pending') ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("Application Date")]), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Account Number")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Name")]), _vm._v(" "), _c('th', [_vm._v("Plan Amount")]), _vm._v(" "), _c('th', [_vm._v("Paid Amount")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pl.planType === 'normal'),
      expression: "pl.planType === 'normal'"
    }]
  }, [_vm._v("No. of EMI")])]), _vm._v(" "), _c('tbody', [_c('td', [_vm._v(_vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecord.member.name) + " (" + _vm._s(_vm.seeRecord.member.code) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mem.accountNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mem.guarantorName))]), _vm._v(" "), (_vm.pl.planType === 'normalReduced') ? _c('td', [_vm._v(_vm._s(_vm.pl.amount + _vm.pl.fileCharge + _vm.pl.processingFee))]) : _vm._e(), _vm._v(" "), (_vm.pl.planType != 'normalReduced') ? _c('td', [_vm._v(_vm._s(_vm.pl.amount + (_vm.pl.fileCharge) + (_vm.pl.amount * _vm.pl.processingFee) / 100))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pl.amount))]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pl.planType === 'normal'),
      expression: "pl.planType === 'normal'"
    }]
  }, [_vm._v(_vm._s(_vm.pl.noOfPayments))])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.seeRecord.status == 'pending') ? _c('table', {
    staticClass: "table"
  }, [_vm._m(29)]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _vm._m(30)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintCustomerEMIModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(31), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printCustomerEMI()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printCustomerEMI"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                          "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                          ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.member_loan_plan.applicationNo,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                            Show this if the rendering fails.\n                          ")])], 1)])]), _vm._v(" "), _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Loan EMI Card")]), _vm._v(" "), (_vm.seeRecord.status == 'disbursed') ? _c('div', [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('th', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Branch : " + _vm._s(_vm.seeRecord.branch.name) + " (" + _vm._s(_vm.seeRecord.branch.branchCode) + ")")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date : " + _vm._s(_vm._f("myDate")(_vm.seeRecord.created_at)))])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Customer Name ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.seeRecord.member.name))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Customer Code ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.seeRecord.member.code))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Contact No ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.seeRecord.member.mobile))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("C/O ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.fatherName))])]), _vm._v(" "), _c('tr', [_vm._m(32), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("₹ " + _vm._s(_vm.planAmt(_vm.seeRecord)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Plan Name ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.pl.name) + " ")])]), _vm._v(" "), _c('tr', [_vm._m(33), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [(_vm.pl.noOfPayments) ? _c('span', [_vm._v(_vm._s(_vm.pl.noOfPayments))]) : _vm._e()]), _vm._v(" "), _vm._m(34), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" ₹ " + _vm._s(_vm.memberFirstEmiRecord))])])])]), _vm._v(" "), _c('h3', [_vm._v("EMI Schedule Terms ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_vm._m(35), _vm._v(" "), _c('tbody', _vm._l((_vm.memberEmiRecords), function(memberEmiRecord) {
    return _c('tr', {
      key: memberEmiRecord.id,
      staticStyle: {
        "border-width": "1px",
        "color": "black"
      }
    }, [_c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black"
      }
    }, [_vm._v(_vm._s(memberEmiRecord.emiNo))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black"
      }
    }, [_vm._v(_vm._s(_vm._f("myDate")(memberEmiRecord.emiDate)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black"
      }
    }, [_vm._v(_vm._s(memberEmiRecord.intrest))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black"
      }
    }, [_vm._v(_vm._s(memberEmiRecord.principal))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black"
      }
    }, [_vm._v(_vm._s(memberEmiRecord.total))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black"
      }
    }, [_vm._v(_vm._s(memberEmiRecord.memberDueAmt))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black"
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black"
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black"
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-width": "2px",
        "color": "black"
      }
    })])
  }), 0)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(36)]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _vm._m(37)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintCustomerModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(38), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printCustomer()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printCustomer"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                          "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                          ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.member_loan_plan.applicationNo,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                            Show this if the rendering fails.\n                          ")])], 1)])]), _vm._v(" "), _c('h1', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Loan Sanction Letter")]), _vm._v(" "), (_vm.seeRecord.status == 'disbursed') ? _c('div', [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('thead', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('th', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Branch : " + _vm._s(_vm.seeRecord.branch.name) + " (" + _vm._s(_vm.seeRecord.branch.branchCode) + ")")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date : " + _vm._s(_vm._f("myDate")(_vm.seeRecord.created_at)))])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('tr', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._m(39), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.seeRecord.member.name) + " (" + _vm._s(_vm.seeRecord.member.code) + ")")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Contact No : ")]), _vm._v(_vm._s(_vm.seeRecord.member.mobile))]), _vm._v(" "), _vm._m(40)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("DOB :")]), _vm._v(" " + _vm._s(_vm._f("myDate")(_vm.mem.dob)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v(" Gender : ")]), _vm._v(_vm._s(_vm.mem.gender))]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  })]), _vm._v(" "), (_vm.mem.spouseName) ? _c('tr', [_vm._m(41), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.spouseName))]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  })]) : _c('tr', [_vm._m(42), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.fatherName))]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  })]), _vm._v(" "), _vm._m(43), _vm._v(" "), _c('tr', [_vm._m(44), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.address) + ", " + _vm._s(_vm.mem.area))]), _vm._v(" "), _vm._m(45), (_vm.mem.state) ? _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.district) + ", " + _vm._s(_vm.mem.state.name) + " - " + _vm._s(_vm.mem.pin))]) : _vm._e()]), _vm._v(" "), _vm._m(46), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Bank : ")]), _vm._v(" "), (_vm.mem.bank) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bank.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Branch : ")]), (_vm.mem.bankBranch) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bankBranch))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Loan ID :")]), _vm._v(" "), (_vm.seeRecord.member_loan_plan) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Plan Name :")]), _vm._v(" " + _vm._s(_vm.pl.name))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Account Holder : ")]), _vm._v(_vm._s(_vm.mem.accountHolderName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Account Number : ")]), _vm._v(" "), (_vm.mem.accountNumber) ? _c('span', [_vm._v(_vm._s(_vm.mem.accountNumber))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate (%) : " + _vm._s(_vm.pl.rateOfInterest) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("GST Include : ")]), _vm._v(_vm._s(_vm.pl.includeGst))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("IFSC : ")]), _vm._v(_vm._s(_vm.mem.ifsc))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Plan Amount :")]), _vm._v(" " + _vm._s(_vm.planAmt(_vm.seeRecord)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("File Charge : ")]), _vm._v(_vm._s(_vm.fileChargeFee(_vm.seeRecord)))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_vm._m(47), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Processing Fee :")]), _vm._v(" " + _vm._s(_vm.processingFee(_vm.seeRecord)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Insurance Fee :")]), _vm._v(" " + _vm._s(_vm.insuranceFee(_vm.seeRecord)))])]), _vm._v(" "), (_vm.pl.rateOfInterest) ? _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Income (INR) : ")]), _vm._v(_vm._s(_vm.mem.incomeAmount))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Occupation : ")]), _vm._v(_vm._s(_vm.mem.jobType))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Recovery type :")]), _vm._v(" " + _vm._s(_vm.pl.recoveryType))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Amount to be Paid :")]), _vm._v(" "), (_vm.seeRecord.loanAmount) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.loanAmount))]) : _c('span', [_vm._v(" " + _vm._s(_vm.pl.amount))])])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Business Name : ")]), _vm._v(_vm._s(_vm.mem.businessName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Income Type : ")]), _vm._v(_vm._s(_vm.mem.incomeType))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("No of Payments : ")]), _vm._v(" "), (_vm.pl.noOfPayments) ? _c('span', [_vm._v(_vm._s(_vm.pl.noOfPayments))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Minimum Income : ")]), _vm._v(_vm._s(_vm.mem.minAmount))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Purpose : ")]), (_vm.seeRecord.purpose) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.purpose.purpose))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Description : ")]), _vm._v(_vm._s(_vm.seeRecord.description))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._m(48), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "120px",
      "height": "140px",
      "float": "right",
      "text-align": "center"
    }
  }, [_c('br'), _c('center', [_vm._v("Guarantor Photo "), _c('br'), _vm._v("with Cross Sign")])], 1)])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._m(49), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.guarantorName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Contact Number : ")]), _vm._v(_vm._s(_vm.mem.guarantorPhone) + " ")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._m(50), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.guarantorAddress))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Narration : ")]), _vm._v(_vm._s(_vm.mem.guarantorNarration))])]), _vm._v(" "), _c('tr', [_vm._m(51), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Nominee Name : ")]), _vm._v(_vm._s(_vm.mem.nomineeName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Contact Number : ")]), _vm._v(_vm._s(_vm.mem.nomineePhone))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Nominee Dob : ")]), _vm._v(_vm._s(_vm.mem.nomineeDob))])])])])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(52)]) : _vm._e()])])])]), _vm._v(" "), _vm._m(53)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(54), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.seeRecord.branch) ? _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.branch.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.branch.branchCode))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Agent Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.agent.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Agent Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.agent.code))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Plan Details")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-striped table-dark"
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Plan Name ")]), _vm._v(" : " + _vm._s(_vm.pl.name))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Plan Type ")]), _vm._v(" : " + _vm._s(_vm.pl.planType))])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Type of Interest")]), _vm._v(" : " + _vm._s(_vm.pl.typeOfInterest) + "\n                            ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Recovery Type")]), _vm._v(" : " + _vm._s(_vm.pl.recoveryType) + "\n                            ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Number of Payments")]), _vm._v(" :\n                              " + _vm._s(_vm.pl.noOfPayments) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Amount")]), _vm._v(" : " + _vm._s(_vm.pl.amount))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Advance Installment")]), _vm._v(" :\n                              " + _vm._s(_vm.pl.acvanceInstallment) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Panulty ")]), _vm._v(": " + _vm._s(_vm.pl.panulty))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Processing Fee ")]), _vm._v(": " + _vm._s(_vm.pl.processingFee) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("File Charge")]), _vm._v(" : " + _vm._s(_vm.pl.fileCharge))]), _vm._v(" "), (_vm.pl.created_by) ? _c('td', [_c('b', [_vm._v("Created By")]), _vm._v(" : " + _vm._s(_vm.pl.created_by.name) + "\n                            ")]) : _vm._e()])])]), _vm._v(" "), (_vm.seeRecord.member_id) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Member Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.member.name))])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.seeRecord.branch) ? _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Plan Type")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.planType))])]), _vm._v(" "), (_vm.seeRecord.collection_center) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center.name))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center.centerCode))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center_leader) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Leader")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center_leader.name))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center_leader) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Leader Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center_leader.code))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Disbursement Date")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.disbursementDate))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("EMI Start Date")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.emiStartDate))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Payment Mode")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.paymentMode))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Status")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.status))])])]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(55)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewGroupMember"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(56), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(57), _vm._v(" "), _c('tbody', _vm._l((_vm.groupMembers), function(groupMem) {
    return _c('tr', {
      key: groupMem.id
    }, [_c('td', [_c('a', [_vm._v(_vm._s(groupMem.member.name))])]), _vm._v(" "), _c('td', [_c('a', [_vm._v(" " + _vm._s(groupMem.member.code))])])])
  }), 0)])])])])])])]), _vm._v(" "), _vm._m(58)])])]), _vm._v(" "), _c('demandprobeshnarynote', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo,
      "pl": _vm.pl,
      "mem": _vm.mem
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Staff ID "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Individual Disbursement List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr.")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("LoanID ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pl Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pl Category")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pl Emi Type")]), _vm._v(" "), _c('th', [_vm._v("Plan Amt")]), _vm._v(" "), _c('th', [_vm._v("Dis Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Dis Dt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Emi Start Dt ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Emi End Dt ")]), _vm._v(" "), _c('th', [_vm._v("Member")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Staff")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pay Mode")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("File Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Payment Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                COLLECT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Processing Fee Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Payment Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                COLLECT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Insurance Fee Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Payment Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                COLLECT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Customer Name ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px",
      "text-align": "right"
    },
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "140px",
      "height": "160px",
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("Customer Photo "), _c('br'), _vm._v("with Cross Sign")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Spouse Name  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("C/O ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Address Details")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Address ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("District/State/Pincode ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Bank Details")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Applied Loan Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Income Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Guarantor Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Name ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Address ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Nominee Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('tr', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Sr. No")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("EMI Date")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Interest")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Principal")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Amount")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Branch Manager Signature")]), _vm._v(" "), _c('th', [_vm._v("Customer Signature")]), _vm._v(" "), _c('th', [_vm._v("Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Plan Amount - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Number of EMI ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("EMI Amount - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "border-width": "1px"
    }
  }, [_c('tr', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Sr. No")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Loan EMI Date")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Interest")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Principal")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Amount")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Remaining Amt")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Receive Date")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Received Amt")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Staff Sign")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v("Senior Sign")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "width": "20%"
    }
  }, [_c('strong', [_vm._v("Customer Name ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px",
      "text-align": "right"
    },
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "140px",
      "height": "160px",
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("Customer Photo "), _c('br'), _vm._v("with Cross Sign")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Spouse Name  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("C/O ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Address Details")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Address ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("District/State/Pincode ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Bank Details")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Applied Loan Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Income Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Guarantor Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Name ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Address ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('strong', [_vm._v("Nominee Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Loan Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Group Member Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Code")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69c8afd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Loan/Disbursment.vue
// module id = 775
// module chunks = 0